import { BlockNodeData } from "./blockNodeData";
import { NodeParticleBlockConnectionPointTypes } from "core/Particles/Node/Enums/nodeParticleBlockConnectionPointTypes";
import { ParticleInputBlock } from "core/Particles/Node/Blocks/particleInputBlock";
export const RegisterDefaultInput = (stateManager) => {
    stateManager.createDefaultInputData = (rootData, portData, nodeContainer) => {
        const point = portData.data;
        const pointName = "output";
        if (point.type === NodeParticleBlockConnectionPointTypes.AutoDetect) {
            return null;
        }
        if (point.type === NodeParticleBlockConnectionPointTypes.Particle) {
            return null;
        }
        const emittedBlock = new ParticleInputBlock(NodeParticleBlockConnectionPointTypes[point.type], point.type);
        const nodeParticleSet = rootData.nodeParticleSet;
        nodeParticleSet.attachedBlocks.push(emittedBlock);
        return {
            data: new BlockNodeData(emittedBlock, nodeContainer),
            name: pointName,
        };
    };
};
//# sourceMappingURL=registerDefaultInput.js.map